class EscapeHandler {
  private listeners = []

  constructor () {
    window.addEventListener('keydown', this.keyDownListener)
  }

  keyDownListener = (e) => {
    if (e.keyCode === 27 && this.listeners.length > 0) {
      this.listeners[this.listeners.length - 1]()
    }
  }

  registerEscapeListener (callback: Function) {
    this.listeners.push(callback)
  }

  removeEscapeListener (callback: Function) {
    this.listeners = this.listeners.filter((listener) => listener !== callback)
  }
}

export default new EscapeHandler()
